import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'

import { Button } from '_zari/core'

import { Breadcrumbs, Typography, Link } from '@material-ui/core'
import HomeIcon from '@material-ui/icons/Home'

import { IdGen } from 'utils'

/**
 * @param {{
 *    className?: string
 *    title?: string
 *    hideClose?: boolean
 *    breadcrumbs?: {
 *      name: string
 *      path: string
 *    }
 *    buttons?: any[]
 * }} props
 * @returns {React.Component}
 */
const PortletHeader = ({ className, title, breadcrumbs, buttons, children, hideClose }) => {
  const history = useHistory()

  const clickBreadcrumb = React.useCallback(
    (e, path) => {
      e.preventDefault()
      history.push(path)
    },
    [history]
  )

  const innerBreadcrumbs = React.useMemo(() => {
    if (breadcrumbs && breadcrumbs.length > 0) {
      const output = [
        <Link key='home-bradcrumb' color='inherit' onClick={e => clickBreadcrumb(e, '/')}>
          <HomeIcon className='zr-portlet__head-breadcrumb__home' />
        </Link>
      ]

      const breadCrumbLength = breadcrumbs.length

      for (let i = 0; i < breadCrumbLength; i++) {
        const element = breadcrumbs[i]

        if (i === breadCrumbLength - 1) {
          output.push(
            <Typography key='typo-active' color='textPrimary'>
              {element.name}
            </Typography>
          )
        } else {
          output.push(
            <Link key={IdGen.newId()} color='inherit' onClick={e => clickBreadcrumb(e, element.path)}>
              {element.name}
            </Link>
          )
        }
      }

      return (
        <Breadcrumbs separator='›' aria-label='Breadcrumb'>
          {output}
        </Breadcrumbs>
      )
    }
    return <></>
  }, [breadcrumbs, clickBreadcrumb])

  const clickClose = React.useCallback(() => {
    history.push('/')
  }, [history])

  return (
    <div className={clsx('zr-portlet__head kt-portlet__head', className)}>
      {title && (
        <div className='zr-portlet__head-label kt-portlet__head-label'>
          {/* {icon} */}

          <h3 className='zr-portlet__head-title kt-portlet__head-title'>{title}</h3>

          {innerBreadcrumbs}
        </div>
      )}
      <div className='zr-portlet__head-toolbar kt-portlet__head-toolbar'>
        {children}
        {buttons &&
          buttons.map(x => (
            <Button key={IdGen.newId()} outline onClick={x.onClick} tiny>
              {x.name}
            </Button>
          ))}
        {!hideClose && (
          <div className='zr-portlet__head--closebutton-container'>
            <button type='button' className='close' onClick={clickClose}>
              <span aria-hidden='true'>×</span>
              <span className='sr-only'>Close</span>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

PortletHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  hideClose: PropTypes.bool,
  children: PropTypes.any
}

export default PortletHeader
